namespace Matrix.Administration {
    export interface GetMatchingPermissionKeysRequest extends Serenity.ServiceRequest {
        PermissionPatterns?: string[];
    }
}
